import { AsProp } from '@squareup/dex-types-shared-ui';
import { Paragraph20 } from '@squareup/dex-ui-shared-base';
import React, { FunctionComponent } from 'react';

import styles from './http-status.module.css';

interface Props {
  status: string | number;
}

const HttpStatus: FunctionComponent<Props & AsProp> = ({ status, as }) => {
  return (
    <Paragraph20
      data-status={status}
      weight="medium"
      as={as}
      className={styles.status}
    >
      {status}
    </Paragraph20>
  );
};

export { HttpStatus };
